import { render, staticRenderFns } from "./Dash.vue?vue&type=template&id=0dc486f9&scoped=true&"
import script from "./Dash.vue?vue&type=script&lang=js&"
export * from "./Dash.vue?vue&type=script&lang=js&"
import style0 from "./Dash.vue?vue&type=style&index=0&id=0dc486f9&lang=sass&scoped=true&"
import style1 from "./Dash.vue?vue&type=style&index=1&id=0dc486f9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc486f9",
  null
  
)

export default component.exports